import { createFileRoute } from "@tanstack/react-router";
import { ModelExplorer, parseExplorerSearch } from "../../features/inference/playground";

export const Route = createFileRoute("/_authed/$org/$project/playground")({
  validateSearch: parseExplorerSearch,
  component: PlaygroundPage,
});

function PlaygroundPage() {
  return <ModelExplorer scope={Route.useParams()} search={Route.useSearch()} defaultView="playground" />;
}
